import {
  ELanguage,
} from '@qmulus/frontend-shared/type/locale.ts';

import {
  TSupportedLocale,
} from './i18n';

export const languageMap: Record<ELanguage, TSupportedLocale> = {
  [ELanguage.EN_GB]: 'en',
  [ELanguage.EN_US]: 'en',
  [ELanguage.DE]: 'de',
  [ELanguage.PL]: 'pl',
  [ELanguage.SK]: 'sk',
};

export function getDefaultLanguage(): ELanguage {
  if (navigator.language.startsWith('sk')) {
    return ELanguage.SK;
  }
  if (navigator.language.startsWith('pl')) {
    return ELanguage.PL;
  }
  if (navigator.language.startsWith('de')) {
    return ELanguage.DE;
  }
  return navigator.language.startsWith('en-US') ? ELanguage.EN_US : ELanguage.EN_GB;
}
